import { createContext, useContext } from 'react';
import type { AuthUser, PendingChallenge } from './types';

export interface AuthCtx {
  user: AuthUser | null;
  loading: boolean;
  pendingChallenge: PendingChallenge | null;
  signIn: (email: string, password: string) => Promise<void>;
  completeNewPassword: (newPassword: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthCtx | null>(null);

export function useAuth(): AuthCtx {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de <AuthProvider>');
  return ctx;
}
